<div class="summary-card" [class.summary-card--inactive]="inactive">
  <i class="pi" [ngClass]="icon"></i>
  <div class="summary-card__content">
    <span class="summary-card__label">{{ label }}</span>
    <span class="summary-card__value">{{ value }}</span>
  </div>
</div>
